import {CrudFormService} from "@/components/business/crud/service/CrudFormService";
import AuthForm from "@/views/management/role/AuthForm.vue";
import MenuForm from "@/views/management/role/MenuForm.vue";
import {markRaw} from "vue";

export default class RoleForm extends CrudFormService {
    async init(): Promise<void> {
        await super.init();
        this.widgetContainer.updateField("widget",  {
            name: "custom",
            component: markRaw(AuthForm),
            meta: {size: {edit: "large", show: "large"}}
        }, "auths");
        this.widgetContainer.updateField("widget",  {
            name: "custom",
            component: markRaw(MenuForm),
            meta: {size: {edit: "large", show: "large"}}
        }, "menus");
    }
}
